module.exports = __webpack_public_path__ + "img/132.d34f386e.svg";